<!-- Ported from vendor-ref/mara/app/ui/src/components/nanome/WorkspaceSettingsPopup.vue (SetSkybox -> store.setSkybox; themes from SKYBOX_THEMES) -->
<script setup lang="ts">
import { computed, ref } from 'vue';
import Popover from 'primevue/popover';
import Button from 'primevue/button';
import Select from 'primevue/select';
import { SKYBOX_THEMES } from '@nanome-lite/look';
import { useLiteStore } from '@nanome-lite/state';
import { useDevice } from '@/composables/device';

const store = useLiteStore();
const device = useDevice();
const panel = ref<InstanceType<typeof Popover>>();

const themes = SKYBOX_THEMES.map(t => ({ key: t.key, name: t.name }));
const theme = computed({
  get: () => store.view.skyboxTheme,
  set: (key: string) => store.setSkybox({ theme: key }),
});

defineExpose({ show: (e: Event) => panel.value?.show(e), hide: () => panel.value?.hide() });
</script>

<template>
  <Popover ref="panel" pt:content="flex flex-col gap-2 w-64">
    <h4 class="my-1">
      Settings
    </h4>

    <div class="flex items-center gap-2">
      <Button
        v-tooltip.top="'Toggle night/day skybox'"
        :icon="store.view.nightMode ? 'i-tabler-moon' : 'i-tabler-sun'"
        severity="secondary"
        size="small"
        rounded
        @click="store.setSkybox({ nightMode: !store.view.nightMode })"
      />
      <Select
        v-model="theme"
        :options="themes"
        option-label="name"
        option-value="key"
        placeholder="Theme"
        append-to="self"
        size="small"
        class="flex-1 rd-4"
      />
    </div>

    <label class="flex items-center justify-between gap-2 text-sm cursor-pointer mt-1">
      Dark interface
      <Button
        :icon="device.isDark.value ? 'i-tabler-moon' : 'i-tabler-sun'"
        severity="secondary"
        size="small"
        rounded
        text
        @click="device.toggleDark()"
      />
    </label>
  </Popover>
</template>
